import { AxiosRequestConfig } from "axios";
import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { Brand, BrandUI } from "../entity/brand.model";

async function getBrands(): Promise<BrandUI[]> {
  let page: BrandUI[] = await api.get(`${mConstants.ORDER_URL}/brands`);

  return page;
}

function getBrand(uuid: string): Promise<Brand> {
  return api.get(`${mConstants.ORDER_URL}/brands/${uuid}`);
}

function editBrand(formData: FormData): Promise<void> {
  const config: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api.put(`${mConstants.ORDER_URL}/brands`, formData, config);
}
function deleteBrand(uuid: string): Promise<void> {
  return api.delete(`${mConstants.ORDER_URL}/brands/${uuid}`);
}
function addBrand(formData: FormData): Promise<void> {
  const config: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api.post(`${mConstants.ORDER_URL}/brands`, formData, config);
}
export const brandService = {
  getBrands,
  getBrand,
  editBrand,
  deleteBrand,
  addBrand,
};
